import marketInDepthCommon from "./common";
import marketInDepthIndex from "./index2";
import marketInDepthAnomaly from "./anomaly";
import marketInDepthValuation from "./valuation";
import marketInDepthProspect from "./prospect";
import marketInDepthLiquidity from "./liquidity";

export default {
  marketInDepthCommon,
  marketInDepthIndex,
  marketInDepthAnomaly,
  marketInDepthValuation,
  marketInDepthProspect,
  marketInDepthLiquidity,
}
